import React from "react";
import { DocProps, DocMap } from "../../Language";
import { GenericTermsISKSV as SV } from "./GenericTermsISKSV";
import "../../Documents.css";

const docsMap: DocMap = { SV };

export const GenericTermsISK: React.FC<DocProps> = props =>
  React.createElement(docsMap[props.language], null);
